export const viewportSyncFrequencyInMs = 500

export const minWindowWidth = 1024
export const minWindowHeight = 560

export const mapSnapshotDefaultViewport = {
    zoom: 3.5,
    latitude: 45,
    longitude: -100,
}
